import FilterBar from "../../FilterBar";

const NavItems = ({
  // Role + preset props
  role,
  onRoleChange,
  activePresetId,
  onApplyPreset,
  shopId,
  staffId,
  accountId,
  pipelineStages,
  currentFilterSnapshot,
  onApplyView,
  // Filter props
  tags,
  tagZalos,
  managers,
  selectedTags,
  selectedTagZalos,
  selectedManagers,
  selectedCategories,
  selectedPipelineStageIds,
  needsReplyMinutes,
  newCustomerDays,
  hasContactInfo,
  upcomingBirthdayDays,
  onTagsChange,
  onTagZalosChange,
  onManagersChange,
  onCategoriesChange,
  onPipelineStagesChange,
  onNeedsReplyMinutesChange,
  onNewCustomerDaysChange,
  onHasContactInfoChange,
  onUpcomingBirthdayDaysChange,
  // Sort props
  sortMode,
  onSortModeChange,
}) => {
  return (
    <div className="flex flex-row items-center gap-1 min-w-0">
      <FilterBar
        role={role}
        onRoleChange={onRoleChange}
        activePresetId={activePresetId}
        onApplyPreset={onApplyPreset}
        shopId={shopId}
        staffId={staffId}
        accountId={accountId}
        pipelineStages={pipelineStages}
        currentFilterSnapshot={currentFilterSnapshot}
        onApplyView={onApplyView}
        tags={tags}
        tagZalos={tagZalos}
        managers={managers}
        selectedTags={selectedTags}
        selectedTagZalos={selectedTagZalos}
        selectedManagers={selectedManagers}
        selectedCategories={selectedCategories}
        selectedPipelineStageIds={selectedPipelineStageIds}
        needsReplyMinutes={needsReplyMinutes}
        newCustomerDays={newCustomerDays}
        hasContactInfo={hasContactInfo}
        upcomingBirthdayDays={upcomingBirthdayDays}
        onTagsChange={onTagsChange}
        onTagZalosChange={onTagZalosChange}
        onManagersChange={onManagersChange}
        onCategoriesChange={onCategoriesChange}
        onPipelineStagesChange={onPipelineStagesChange}
        onNeedsReplyMinutesChange={onNeedsReplyMinutesChange}
        onNewCustomerDaysChange={onNewCustomerDaysChange}
        onHasContactInfoChange={onHasContactInfoChange}
        onUpcomingBirthdayDaysChange={onUpcomingBirthdayDaysChange}
        sortMode={sortMode}
        onSortModeChange={onSortModeChange}
      />
    </div>
  );
};

export default NavItems;
